import Pagination from '@cred/react-pagination'
import { compose } from 'redux'
import { emitOnPageChange, withLinkClickEvent } from '@cred/react-analytics/hoc'

const PaginationWithAnalytic = compose(withLinkClickEvent, emitOnPageChange)(Pagination)

export default PaginationWithAnalytic
